import { render, staticRenderFns } from "./AssetsFilters.vue?vue&type=template&id=d6bc0f64&"
import script from "./AssetsFilters.vue?vue&type=script&lang=js&"
export * from "./AssetsFilters.vue?vue&type=script&lang=js&"
import style0 from "./AssetsFilters.vue?vue&type=style&index=0&id=d6bc0f64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports